import App from './app.js'

const app = new App(document.querySelector('main'))

void app.start()

window.addEventListener('beforeunload', () => {
  app.destroy()
})
